import BlockIcon from '@mui/icons-material/Block';
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import type { ReactNode } from 'react';
import { type AudienceListType, ListType } from '../../../types.ts';
import { getHoverableItemStyles } from './utils/hoverableItemStyles.ts';

type BaseHoverableItemProps = {
  children: ReactNode;
  type: AudienceListType;
};

export type HoverableItemProps = BaseHoverableItemProps &
  ({ readOnly: true } | { readOnly?: false; onDelete: () => void; isNested?: boolean });

export const HoverableItem = ({ children, type, ...rest }: HoverableItemProps) => {
  const styles = getHoverableItemStyles({
    readOnly: !!rest.readOnly,
    isNested: 'isNested' in rest ? rest.isNested : undefined,
  });

  return (
    <Box sx={styles.root}>
      <Box sx={styles.iconBox}>
        {type === ListType.INCLUDES ? (
          <CheckCircleOutlined data-test="check-icon" color="success" fontSize="small" />
        ) : (
          <BlockIcon data-test="block-icon" color="error" fontSize="small" />
        )}
      </Box>

      <Box sx={styles.contentBox}>{children}</Box>

      {!rest.readOnly && (
        <Box className="hoverable" sx={styles.hoverableBox}>
          <IconButton size="small" sx={styles.closeButton} onClick={rest.onDelete}>
            <CloseIcon data-test="close-icon" />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};
